var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gallery_edit_btn",on:{"click":function($event){return _vm.movePage('/gallery')}}},[_vm._v(_vm._s(_vm.$t('gallery_setting')))]),_c('div',{staticClass:"clear"}),_c('gallery-list-component',{attrs:{"gallery-type":'profileGallery',"defaultFilter":{no: _vm.UserInfo.mb_no}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }